export function rex_email(email) {
	const rex =
		/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return rex.test(String(email).toLowerCase());
}
export function rex_phoneNum(phoneNum) {
	const rex = /^09\d{8}$/;
	return rex.test(String(phoneNum));
}
export function rex_number(number) {
	if (!rex_value(number)) return false;
	return !isNaN(Number(number));
}
export function rex_int(number) {
	if (!rex_value(number)) return false;
	if (!rex_number(number)) return false;
	return /\d+/.test(number);
}
export function rex_positive(number) {
	if (!rex_value(number)) return false;
	if (!rex_number(number)) return false;
	return number > 0;
}
export function rex_password(password) {
	const rex = /^.{8,}$/;
	return rex.test(String(password));
}
export function rex_value(val) {
	if (typeof val === "string") val = val.trim();
	return [undefined, null, NaN, ''].indexOf(val) === -1;
}